import { Pagination, Table } from 'antd';
import React, { FC } from 'react';
import { TCommonColumns, TCommonPreparedData } from 'shared/types/overtime.types';
import style from './index.module.scss';

type TProps = {
  dataSource: TCommonPreparedData;
  columns: TCommonColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  onclickToRow?: (id: number) => void;
  selfPaginated?: boolean;
};

const CommonTable: FC<TProps> = ({
  columns,
  currentPage,
  currentSize,
  dataSource,
  setCurrentPage,
  setCurrentSize,
  total,
  onclickToRow,
  selfPaginated = false,
}) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };
  return (
    <>
      <Table
        scroll={{ x: true }}
        dataSource={dataSource}
        columns={columns}
        rowClassName="row"
        pagination={
          selfPaginated
            ? {
                defaultCurrent: 1,
                showSizeChanger: true,
                current: currentPage,
                total: total,
                pageSize: currentSize,
                onChange: (page, pageSize) => handlePagination(page, pageSize),
              }
            : false
        }
        bordered
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              if (onclickToRow) {
                onclickToRow(+record.id!);
              }
            },
          };
        }}
      />
      {!selfPaginated && (
        <div className={style.paginationWrap}>
          <Pagination
            defaultCurrent={1}
            showSizeChanger
            current={currentPage}
            total={total}
            pageSize={currentSize}
            onChange={(page, pageSize) => handlePagination(page, pageSize)}
          />
        </div>
      )}
    </>
  );
};

export default CommonTable;
